import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { selectUserData } from '../reducers/userDataReducer'
import { selectActiveBuilding } from '../reducers/buildingSelectorReducer'

export const ADMIN_OR_PM = ['Administrator', 'Manager', 'PropertyManager']
const CLIENT_CANT = [...ADMIN_OR_PM, 'Manager', 'Trainer', 'ShiftManager']
const CLIENT = ['Client']

export const ABILITIES = {
  ManagerCalendar: {
    seeToolbar: ['Administrator', 'Manager', 'Trainer'],
  },
  PM_FD_Calendar: {
    seeToolbar: ['PropertyManager', 'ShiftManager'],
  },
  Navbar: {
    clients: [...ADMIN_OR_PM, 'ShiftManager'],
    units: ADMIN_OR_PM,
    organisation: ['Administrator', 'Manager'],
    booking: CLIENT,
    buildingEssentials: [...CLIENT, 'Administrator', 'PropertyManager'],
    neighbourPerks: CLIENT,
    store: CLIENT,
    classes: CLIENT,
    notifications: ['Administrator', 'PropertyManager', 'ShiftManager', 'Staff'],
    communicate: ['Administrator', 'PropertyManager', 'Manager'],
    nPortal: CLIENT,
    buildingAnalytics: ADMIN_OR_PM,
    chat: ['PropertyManager', 'ShiftManager', 'Administrator', 'Manager', 'Staff'],
    buildingDashboard: [...ADMIN_OR_PM, 'ShiftManager', ...CLIENT, 'Staff'],
    buildingDashboardV2: ['Administrator', 'Manager', 'PropertyManager'],
    serviceForm: ['Administrator'],
    clientReservations: CLIENT,
    reservations: [...ADMIN_OR_PM, 'ShiftManager'],
    reservation_amenities: [...ADMIN_OR_PM],
    visitors: [...ADMIN_OR_PM, 'ShiftManager'],
    packages: [...ADMIN_OR_PM, 'ShiftManager'],
    marketShop: [...ADMIN_OR_PM],
    groups: [...ADMIN_OR_PM],
    groupsCopyUrl: ['PropertyManager'],
    marketplaceFeed: ADMIN_OR_PM,
    actionLog: [...ADMIN_OR_PM, 'ShiftManager'],
    instructions: ['PropertyManager', 'ShiftManager'],
    socialLink: [...ADMIN_OR_PM],
    checklists: ADMIN_OR_PM,
    maintenance: [...ADMIN_OR_PM, 'Staff', 'ShiftManager'],
    maintenance_staff: [...ADMIN_OR_PM],
    calendar: [...ADMIN_OR_PM, 'ShiftManager', 'Trainer', ...CLIENT],
    marketing: ADMIN_OR_PM,
    rewards: ADMIN_OR_PM,
    managementUsers: ADMIN_OR_PM,
    parking: ADMIN_OR_PM,
    parkingManagement: [...ADMIN_OR_PM, 'ShiftManager'],
    internalInspections: ['PropertyManager', 'Administrator'],
    incidentReports: ['PropertyManager', 'Administrator', 'ShiftManager'],
    assetTracking: ['PropertyManager', 'Administrator', 'ShiftManager'],
    workOrdersOffice: ['PropertyManager', 'Administrator', 'ShiftManager'],
    frontDesk: ['PropertyManager', 'Administrator', 'ShiftManager'],
    restaurantManager: ['PropertyManager', 'Administrator', 'ShiftManager'],
    customerPortal: ['Administrator', 'PropertyManager'],
    integrationsPM: ['PropertyManager'],
    websiteWidgets: ADMIN_OR_PM,
    payments: CLIENT,
  },
  Calendar: {
    see: [...ADMIN_OR_PM, 'Trainer', ...CLIENT, 'ShiftManager'],
    managementCalendar: CLIENT_CANT,
    clientCalendar: CLIENT,
  },
  UserProfile: {
    update: ['Administrator', 'Manager', 'PropertyManager', 'Staff', 'Trainer', ...CLIENT],
    buildingCode: CLIENT,
    editBuildingCode: CLIENT,
    birthDate: CLIENT,
    gender: ['PropertyManager', 'Trainer', ...CLIENT],
    phone: ['Trainer', ...CLIENT],
    address: ['Trainer', ...CLIENT],
    notification: CLIENT,
    newsletter: CLIENT,
  },
}

// Todo refactor to CASL
// Class for managing permissions for auth users
class Can extends Component {
  static can = (to, on, role) => {
    return ABILITIES[on][to].includes(role) || ABILITIES[on][to].includes('all')
  }

  isAnyAvailable(feedFlags) {
    if (!feedFlags.length) return true
    if (this.props.allBuildings && this.props.allBuildingsData) {
      return this.props.allBuildingsData.some((someBuilding) =>
        feedFlags.some((flag) => someBuilding[flag]),
      )
    }
    return feedFlags.some((flag) => this.props.buildingData[flag])
  }

  isAllAvailable(feedFlags) {
    if (!feedFlags.length) return true
    if (this.props.allBuildings && this.props.allBuildingsData) {
      return this.props.allBuildingsData.some((someBuilding) =>
        feedFlags.every((flag) => someBuilding[flag]),
      )
    }
    return feedFlags.every((flag) => this.props.buildingData[flag])
  }

  render() {
    const {
      children,
      role,
      to,
      on,
      feedFlag,
      isAll,
      isAny,
      buildingData,
      allBuildings,
      allBuildingsData,
      upsellingLink,
      forceHideChildren,
    } = this.props
    const isBuildingOptionAvailable = () => {
      if (role === 'Administrator') return true
      if (feedFlag && allBuildings && allBuildingsData && allBuildingsData.length) {
        if (isAny) {
          return this.isAnyAvailable(feedFlag)
        } else if (isAll) {
          return this.isAllAvailable(feedFlag)
        } else {
          return allBuildingsData.some((someBuilding) => someBuilding[feedFlag])
        }
      } else if (feedFlag && buildingData) {
        if (isAny) {
          return this.isAnyAvailable(feedFlag)
        } else if (isAll) {
          return this.isAllAvailable(feedFlag)
        } else {
          return buildingData[feedFlag]
        }
      } else {
        return !feedFlag || !allBuildingsData || !buildingData
      }
    }

    if (typeof to === 'undefined') {
      return typeof children.type === 'function'
        ? React.cloneElement(children, {
            to: to,
            on: on,
            _can: (to) => Can.can(to, on, role),
          })
        : React.cloneElement(children, {
            _can: (to) => Can.can(to, on, role),
          })
    } else if (
      (ABILITIES[on][to].includes(role) || ABILITIES[on][to].includes('all')) &&
      isBuildingOptionAvailable()
    ) {
      return typeof children.type === 'function'
        ? React.cloneElement(children, {
            to: to,
            on: on,
            _can: (to) => Can.can(to, on, role),
          })
        : children
    } else {
      if (forceHideChildren) {
        return null
      }

      if (upsellingLink && !['Client', 'Administrator'].includes(role)) {
        return upsellingLink
      }
      return null
    }
  }
}

Can.propTypes = {
  children: PropTypes.object,
  role: PropTypes.string,
  to: PropTypes.string,
  on: PropTypes.string,
  feedFlag: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  isAny: PropTypes.bool,
  isAll: PropTypes.bool,
  allBuildings: PropTypes.bool,
  buildingData: PropTypes.object,
  allBuildingsData: PropTypes.array,
  upsellingLink: PropTypes.object,
  forceHideChildren: PropTypes.bool,
}

export default connect((state) => {
  const userData = selectUserData(state)
  const role = typeof userData.user !== 'undefined' ? userData.user.role : 'all'
  return {
    role,
    buildingData: selectActiveBuilding(state) || userData.buildingId,
    allBuildingsData: userData.buildingIds,
  }
})(Can)
